









import { defineComponent, PropType, ref } from "@vue/composition-api"
import { useActions, useGetters } from "vuex-composition-helpers"
import ActionAtom from "@/shared/components/atoms/card/ActionAtom.vue"
import { ButtonType } from "@/apps/StudentExchangeOverviewWidget/models/shared-viewmodel"
import { ExchangeType } from "@/apps/StudentExchangeOverviewWidget/models/exchanges-viewmodel"

export default defineComponent({
    name: "ExchangeActionMolecule",
    components: { ActionAtom },
    props: {
        buttonType: {
            type: String as PropType<ButtonType>,
            required: true
        },
        programOfStudyId: {
            type: Number,
            required: true,
            default: null
        },
        academicYearId: {
            type: String,
            required: true,
            default: null
        },
        exchangeId: {
            type: String,
            required: true,
            default: null
        },
        type: {
            type: String as PropType<ExchangeType>,
            required: true,
            default: null
        }
    },
    setup(props) {
        const {
            getLabels,
        } = useGetters([
            'getLabels'
        ])
        const {
            exchangeAction
        } = useActions([
            'exchangeAction'
        ])
        const label = ref('')
        const icon = ref('')
        const action = ref('')
        
        switch (props.buttonType) {
            case ButtonType.View:
                label.value = getLabels.value.buttonExchangeView
                icon.value = 'fa-light fa-eye'
                action.value = ButtonType.View
                break
            case ButtonType.Edit:
                label.value = getLabels.value.buttonExchangeEdit
                icon.value = 'fa-light fa-pen-to-square'
                action.value = ButtonType.Edit
                break
            case ButtonType.Cancel:
                label.value = getLabels.value.buttonExchangeCancel
                icon.value = 'fa-light fa-chart-simple-horizontal'
                action.value = ButtonType.Cancel
                break
            case ButtonType.Apply:
                label.value = getLabels.value.buttonExchangeApplyScholarship
                icon.value = 'fa-light fa-sack'
                action.value = ButtonType.Apply
                break
        }
        
        function navigate() {
            exchangeAction(action.value, props.type, props.programOfStudyId, props.academicYearId, props.exchangeId)
        }
        
        return {
            navigate,
            action,
            label,
            icon
        }
    }
})
